import { theme } from '../../../../../../../../core/theme/theme';
import { DirectionalPoints } from '../../../../../../../../core/types/types';

export const generateSlopeDistanceLinePoints = (
    highestPolygonDirectionalPoints: DirectionalPoints,
    lowestPolygonDirectionalPoints: DirectionalPoints,
) => {
    return [
        {
            highest: highestPolygonDirectionalPoints.North,
            lowest: lowestPolygonDirectionalPoints.South,
            color: theme.colors.directions.north,
        },
        {
            highest: highestPolygonDirectionalPoints.Northeast,
            lowest: lowestPolygonDirectionalPoints.Southwest,
            color: theme.colors.directions.northeast,
        },
        {
            highest: highestPolygonDirectionalPoints.Northwest,
            lowest: lowestPolygonDirectionalPoints.Southeast,
            color: theme.colors.directions.northwest,
        },
        {
            highest: highestPolygonDirectionalPoints.South,
            lowest: lowestPolygonDirectionalPoints.North,
            color: theme.colors.directions.south,
        },
        {
            highest: highestPolygonDirectionalPoints.Southeast,
            lowest: lowestPolygonDirectionalPoints.Northwest,
            color: theme.colors.directions.southeast,
        },
        {
            highest: highestPolygonDirectionalPoints.Southwest,
            lowest: lowestPolygonDirectionalPoints.Northeast,
            color: theme.colors.directions.southwest,
        },
        {
            highest: highestPolygonDirectionalPoints.West,
            lowest: lowestPolygonDirectionalPoints.East,
            color: theme.colors.directions.west,
        },
        {
            highest: highestPolygonDirectionalPoints.East,
            lowest: lowestPolygonDirectionalPoints.West,
            color: theme.colors.directions.east,
        },
    ];
};
